import React, { lazy, Suspense } from "react";
import ExecutionEnvironment from "exenv";

// Components
import CustomMeta from "../components/CustomMeta/CustomMeta";
const BlogPosts = lazy(() =>
  import(/* webpackChunkName: "BlogPosts" */ "../components/Blog/BlogPosts")
);

// redux stuff
import { connect } from "react-redux";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  fullPageHeight: {
    minHeight: "100vh",
    width: "100%",
  },
}));

function blog() {
  const { classes } = useStyles();

  return (
    <div className={classes.fullPageHeight}>
      <CustomMeta
        title={`Blog - Content Generator`}
        description={`Discover expert social media marketing strategies, tutorials, and best practices for e-commerce, blogs, and affiliate marketing. Learn how to create high-converting social media posts with Content Generator.`}
        url={`https://contentgenerator.io/blog`}
      />
      {ExecutionEnvironment.canUseDOM && (
        <Suspense fallback={<div />}>
          <BlogPosts />
        </Suspense>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps)(blog);
